module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Extinguisher-Water/Fire-Extinguisher-Water.svg";